var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 1439.999935",
    height: 1920,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "74b70dddc3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 206.777344 470.339844 L 603.527344 470.339844 L 603.527344 867.089844 L 206.777344 867.089844 Z M 206.777344 470.339844 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74b70dddc3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 405.152344 470.339844 C 295.589844 470.339844 206.777344 559.152344 206.777344 668.714844 C 206.777344 778.277344 295.589844 867.089844 405.152344 867.089844 C 514.714844 867.089844 603.527344 778.277344 603.527344 668.714844 C 603.527344 559.152344 514.714844 470.339844 405.152344 470.339844 Z M 345.28125 765.957031 L 303.585938 765.957031 L 303.585938 633.839844 L 345.28125 633.839844 Z M 323.363281 617.316406 L 323.066406 617.316406 C 307.96875 617.316406 298.1875 607.21875 298.1875 594.402344 C 298.1875 581.589844 308.265625 571.472656 323.660156 571.472656 C 339.054688 571.472656 348.496094 581.332031 348.8125 594.382812 C 348.8125 607.179688 339.054688 617.316406 323.382812 617.316406 Z M 512.117188 765.957031 L 464.824219 765.957031 L 464.824219 697.578125 C 464.824219 679.683594 457.425781 667.464844 441.15625 667.464844 C 428.71875 667.464844 421.796875 675.71875 418.582031 683.652344 C 417.371094 686.507812 417.570312 690.476562 417.570312 694.445312 L 417.570312 765.9375 L 370.734375 765.9375 C 370.734375 765.9375 371.328125 644.832031 370.734375 633.820312 L 417.570312 633.820312 L 417.570312 654.550781 C 420.328125 645.484375 435.304688 632.550781 459.1875 632.550781 C 488.828125 632.550781 512.117188 651.554688 512.117188 692.480469 Z M 512.117188 765.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.320ad2280d8263d8c10bca250a6f6fa8.svg";
export { ForwardRef as ReactComponent };